export default __webpack_public_path__ + "static/media/home-3.e08c7857.jpg";